module.exports = __webpack_public_path__ + "media/components/assets/img/logo/british_airways-0e2cbec6478abb48dcf2a29220b79985.png";